import { createAction } from '@reduxjs/toolkit';
import type { ClientEnv } from 'constants/Chat.constants';

export const projectInit = createAction('projectInit');
export const createNewChat = createAction('createNewChat');
export const createNewCall = createAction('createNewCall');
export const closeSidePanel = createAction('closeSidePanel');
export const resetUploadStatus = createAction('resetUploadStatus');
export const resetChat = createAction<{
  clientEnv?: ClientEnv;
  variantName?: string;
}>('resetChat');
